import { jsx as _jsx } from "react/jsx-runtime";
var Play = function Play(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.76205 4.46892C7.42891 4.26392 7 4.50359 7 4.89475V19.1052C7 19.4963 7.42891 19.736 7.76205 19.531L19.308 12.4258C19.6253 12.2306 19.6253 11.7694 19.308 11.5741L7.76205 4.46892Z",
      fill: "#181B32",
      stroke: color,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
export default Play;